import { jsx as _jsx } from "react/jsx-runtime";
import { createRoot } from "react-dom/client";
import { App } from "./components/App";
import { createBrowserRouter, Navigate, RouterProvider, } from "react-router-dom";
import React, { Suspense } from "react";
import { ApiClientProvider } from "@/context/ApiClientContext";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import { apiClient } from "./api/ApiClient";
// PAGES
import HomePage from "@/pages/home/HomePage";
import LoginPage from "@/pages/login/LoginPage";
import RegisterPage from "@/pages/register/RegisterPage";
import AboutPage from "@/pages/about/AboutPage";
import NotFoundPage from "@/pages/notfound/NotFoundPage";
import ProfilePage from "@/pages/profile/ProfilePage";
import ProductDetailsPage from "@/pages/productDetails/ProductDetailsPage";
import CategoryPage from "@/pages/category/CategoryPage";
import ProductsPage from "@/pages/products/ProductsPage";
import SearchResultsPage from "@/pages/search/SearchResultsPage";
import CategoryProductsPage from "@/pages/category/CategoryProductsPage";
import CartPage from "@/pages/cart/CartPage";
const root = document.getElementById("root");
if (!root) {
    throw new Error("root not found");
}
const container = createRoot(root);
const router = createBrowserRouter([
    {
        path: "/",
        element: _jsx(App, {}),
        children: [
            {
                index: true,
                element: (_jsx(Suspense, { fallback: "Loading...", children: _jsx(HomePage, {}) })),
            },
            {
                path: "/login",
                element: (_jsx(Suspense, { fallback: "Loading...", children: _jsx(LoginPage, {}) })),
            },
            {
                path: "/register",
                element: (_jsx(Suspense, { fallback: "Loading...", children: _jsx(RegisterPage, {}) })),
            },
            {
                path: "/about",
                element: (_jsx(Suspense, { fallback: "Loading...", children: _jsx(AboutPage, {}) })),
            },
            {
                path: "/profile",
                element: (_jsx(Suspense, { fallback: "Loading...", children: _jsx(ProtectedRoute, { children: _jsx(ProfilePage, {}) }) })),
            },
            {
                path: "/cart",
                element: (_jsx(Suspense, { fallback: "Loading...", children: _jsx(CartPage, {}) })),
            },
            {
                path: "/product",
                element: _jsx(Navigate, { to: "/products", replace: true }),
            },
            {
                path: "/products",
                element: _jsx(ProductsPage, {}),
            },
            {
                path: "/product/:id",
                element: (_jsx(Suspense, { fallback: "Loading...", children: _jsx(ProductDetailsPage, {}) })),
            },
            {
                path: "/category",
                element: _jsx(CategoryPage, {}),
            },
            {
                path: "/category/:categorySlug",
                element: _jsx(CategoryProductsPage, {}),
            },
            {
                path: "/search",
                element: _jsx(SearchResultsPage, {}),
            },
            {
                path: "*",
                element: (_jsx(Suspense, { fallback: "Loading...", children: _jsx(NotFoundPage, {}) })),
            },
        ],
    },
]);
apiClient.initClientFromStorage();
container.render(_jsx(ApiClientProvider, { children: _jsx(RouterProvider, { router: router }) }));
